import { render, staticRenderFns } from "./AddProductAttributesOverviewStep.vue?vue&type=template&id=6a0261c4&scoped=true"
import script from "./AddProductAttributesOverviewStep.ts?vue&type=script&lang=ts&external"
export * from "./AddProductAttributesOverviewStep.ts?vue&type=script&lang=ts&external"
import style0 from "./AddProductAttributesOverviewStep.scss?vue&type=style&index=0&id=6a0261c4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0261c4",
  null
  
)

export default component.exports